import { DefaultTheme } from 'styled-components'
import { darkModeProperties, theme } from './theme'

const ukFonts = {
    title: 'Ubuntu Bold',
    text: 'Nunito Semi Bold',
    text_bold: 'Nunito Extra Bold',
}

const ukHeadingSpacing = 'normal'
const ukTextSpacing = '0.32px'

const ukTheme = {
    ...theme,
    fonts: {
        ...theme.fonts,
        ...ukFonts,
    },
    textVariants: {
        heading1: {
            ...theme.textVariants.heading1,
            fontFamily: ukFonts.title,
            letterSpacing: ukHeadingSpacing,
        },
        heading2: {
            ...theme.textVariants.heading2,
            fontFamily: ukFonts.title,
            letterSpacing: ukHeadingSpacing,
        },
        heading3: {
            ...theme.textVariants.heading3,
            fontFamily: ukFonts.title,
            letterSpacing: ukHeadingSpacing,
        },
        heading4: {
            ...theme.textVariants.heading4,
            fontFamily: ukFonts.title,
            letterSpacing: ukHeadingSpacing,
        },
        heading5: {
            ...theme.textVariants.heading5,
            fontFamily: ukFonts.title,
            letterSpacing: ukHeadingSpacing,
        },
        bodyLargeStrong: {
            ...theme.textVariants.bodyLargeStrong,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        bodyLarge: {
            ...theme.textVariants.bodyLarge,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        bodyStrong: {
            ...theme.textVariants.bodyStrong,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        body: {
            ...theme.textVariants.body,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        bodySmallStrong: {
            ...theme.textVariants.bodySmallStrong,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        bodySmall: {
            ...theme.textVariants.bodySmall,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        bodyExtraSmallStrong: {
            ...theme.textVariants.bodyExtraSmallStrong,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        bodyExtraSmall: {
            ...theme.textVariants.bodyExtraSmall,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        body16Strong: {
            ...theme.textVariants.body16,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        body16: {
            ...theme.textVariants.body16,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        body14Strong: {
            ...theme.textVariants.body14,
            fontFamily: ukFonts.text_bold,
            letterSpacing: ukTextSpacing,
        },
        body14: {
            ...theme.textVariants.body14,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
        body12: {
            ...theme.textVariants.body12,
            fontFamily: ukFonts.text,
            letterSpacing: ukTextSpacing,
        },
    },
}

const ukDarkMode: DefaultTheme = {
    ...ukTheme,
    ...darkModeProperties,
}

export { ukTheme, ukDarkMode }
